import React from 'react';
import { SwipeableDrawer, ListItemIcon, ListItemText, List, MenuItem } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { withStyles } from "tss-react/mui";
import {
  FaHome as WelcomeIcon,
  FaInfo as AboutIcon,
  FaChartLine as PerformanceIcon,
  FaImage as ImageIcon,
  FaBullhorn as ExposureIcon,
  FaUserCog as AccountSettingsIcon,
  FaShieldAlt as PrivacyIcon,
  FaChartPie as DashboardIcon,
} from 'react-icons/fa';
import isMobile from 'utils/isMobile';
import useStyles from './styles';
import { useAuth } from 'utils/useAuth';
import routes from 'routes';

const StyledMenuItem = withStyles(
  (props => <MenuItem {...props} />),
  {
    root: { width: '100%' }
  },
);

const menuOrder = [
  '/',
  '/Dashboard',
  '/Performance',
  '/Image',
  '/Exposure',
  '/AccountSettings',
  '/AboutUs',
  '/PrivacyPolicy',
];

const iconMap = {
  '/': WelcomeIcon,
  '/Dashboard': DashboardIcon,
  '/Performance': PerformanceIcon,
  '/Image': ImageIcon,
  '/Exposure': ExposureIcon,
  '/AboutUs': AboutIcon,
  '/AccountSettings': AccountSettingsIcon,
  '/PrivacyPolicy': PrivacyIcon,
};

function Menu({ isOpen, onClose, onOpen }) {
  const classes = useStyles({
    isOpen,
    isMobile,
  }).classes;

  const { user } = useAuth();

  const allMenuItems = routes.flatMap(route => 
    route.children 
      ? route.children.map(child => ({ ...child, authenticated: true }))
      : [route]
  ).filter(route => 
    route.path && route.path !== '/Login' && (route.authenticated !== true || user)
  );

  const menuItems = menuOrder
    .map(path => allMenuItems.find(item => item.path === path))
    .filter(Boolean);

  return (
    <SwipeableDrawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      swipeAreaWidth={30}
      disableBackdropTransition={true}
    >
      <List className={classes.list}>
        <div className={classes.toolbar} />
        {menuItems.map((item, index) => {
          const Icon = iconMap[item.path] || AboutIcon;
          return (
            <StyledMenuItem
              key={index}
              onClick={onClose}
              component={RouterLink}
              to={item.path}
            >
              <ListItemIcon>
                <Icon />
              </ListItemIcon>
              <ListItemText primary={item.path === '/' ? 'Home' : item.path.slice(1).replace('-', ' ')} />
            </StyledMenuItem>
          );
        })}
      </List>
    </SwipeableDrawer>
  );
}

export default Menu;